import { useState, useEffect } from 'react';
import { Container, Typography, Box } from '@mui/material';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import EmployeeManagement from './Employeemanagement';
import ReportForm from './Reportform';
import ReportTable from './ReportTable';
import ReportView from './ReportView';
import VehicleManagement from './Vehiclemanagement';
import EmailConfig from './Emailconfig';
import LocationManagement from './Locationmanagement';
import HRManagement from './Hrmanagement';
import axios from 'axios';
import logo from './assets/ZVENTURES-Logo-2.png';

const API = 'https://attend.zventures.in';

const App = () => {
  const [user, setUser]           = useState(null);
  const [employees, setEmployees] = useState([]);
  const [vehicles, setVehicles]   = useState([]);
  const [reports, setReports]     = useState([]);
  const [locations, setLocations] = useState([]);

  const fetchAll = (token) => {
    const h = { Authorization: `Bearer ${token}` };
    axios.get(`${API}/api/employees`, { headers: h }).then(r => setEmployees(r.data)).catch(console.error);
    axios.get(`${API}/api/vehicles`,  { headers: h }).then(r => setVehicles(r.data)).catch(console.error);
    axios.get(`${API}/api/reports`,   { headers: h }).then(r => setReports(r.data)).catch(console.error);
    axios.get(`${API}/api/locations`, { headers: h }).then(r => setLocations(r.data)).catch(console.error);
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setUser(JSON.parse(localStorage.getItem('user')));
      fetchAll(token);
    }
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
    fetchAll(token);
  };

  const handleLogout = () => {
    localStorage.clear();
    setUser(null);
    setEmployees([]); setVehicles([]); setReports([]); setLocations([]);
  };

  const isAdmin = user?.role === 'admin';

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login onLogin={handleLogin} />} />

      <Route path="/" element={user ? (
        <Container sx={{ mt: 6, position: 'relative' }}>
          {/* Logout */}
          <Box sx={{ position: 'absolute', top: 16, right: 16 }}>
            <button onClick={handleLogout}
              style={{ background:'#ef5350', color:'#fff', border:'none', padding:'8px 18px', borderRadius:6, cursor:'pointer', fontWeight:'bold' }}>
              Logout
            </button>
          </Box>

          {/* Header */}
          <Box textAlign="center" mb={4} sx={{ display:'flex', flexDirection:'column', alignItems:'center' }}>
            <img src={logo} alt="Logo" style={{ height:60, marginBottom:16 }} />
            <Typography variant="h4" fontWeight="bold">Staff Bus Onboarding Tracker</Typography>
            <Typography variant="subtitle2" color="text.secondary">
              {isAdmin ? 'Administrator' : `HR — ${user.location}`}
              {user.name ? ` · ${user.name}` : ''}
            </Typography>
          </Box>

          {/* Admin-only panels */}
          {isAdmin && (
            <>
              <LocationManagement locations={locations} setLocations={setLocations} />
              <EmployeeManagement employees={employees} setEmployees={setEmployees} locations={locations} />
              <VehicleManagement  vehicles={vehicles}   setVehicles={setVehicles}   locations={locations} />
              <HRManagement locations={locations} />
              <EmailConfig  locations={locations} />
            </>
          )}

          {/* Report submission — visible to both admin and HR */}
          <ReportForm
            employees={employees}
            vehicles={vehicles}
            setReports={setReports}
            location={user.location}
            isAdmin={isAdmin}
            locations={locations}
          />
          <ReportTable reports={reports} />
        </Container>
      ) : <Navigate to="/login" />} />

      <Route path="/report/:reportId" element={<ReportView />} />
    </Routes>
  );
};

export default App;